module.exports = __webpack_public_path__ + "img/savosin.7408c9f4.png";